import React, { useState } from "react";
import http from "../../../../services/http";

/**
 * 30/10/2026 (Quân): trạm gửi giấy tờ qua email / WhatsApp ⇒ Admin tải lên thay, rồi duyệt bằng đúng nút đang có.
 * Bắt ghi nguồn nhận. Giấy chỉ định do Admin tải ⇒ người tải không tự duyệt (muốn tự duyệt phải ghi lý do).
 */
const o: React.CSSProperties = { padding: "4px 8px", border: "1px solid #D0D5DD", borderRadius: 8, minWidth: 0 };
const nut: React.CSSProperties = {
	border: "none",
	background: "#1565c0",
	color: "#fff",
	borderRadius: 8,
	padding: "5px 12px",
	cursor: "pointer",
};

async function taiTep(files: FileList | null): Promise<string[]> {
	if (!files || !files.length) return [];
	const fd = new FormData();
	Array.from(files).forEach((f) => fd.append("files", f));
	const { data } = await http.post("/gcs-upload-multiple-file?folder=documents/station-licences", fd, {
		headers: { "Content-Type": "multipart/form-data" },
	});
	return (data || []).map((x: any) => x.path || x.url || x.filename).filter(Boolean);
}

const loiCua = (e: any) => e?.response?.data?.message || e?.message || "Could not save. Please try again.";

export function TaiThayGiayPhep(props: { partnerId: string; onDone?: () => void }) {
	const [mo, setMo] = useState(false);
	const [tep, setTep] = useState<FileList | null>(null);
	const [nguon, setNguon] = useState("");
	const [busy, setBusy] = useState(false);
	const [tb, setTb] = useState("");
	const gui = async () => {
		setTb("");
		if (!tep?.length || !nguon.trim()) return setTb("Choose the file(s) and write where they came from.");
		setBusy(true);
		try {
			const files = await taiTep(tep);
			await http.post(`/admin/partners/${props.partnerId}/business-licence-upload`, {
				files,
				source: nguon.trim(),
			});
			setMo(false);
			setTep(null);
			setNguon("");
			props.onDone?.();
		} catch (e) {
			setTb(loiCua(e));
		} finally {
			setBusy(false);
		}
	};
	if (!mo)
		return (
			<button
				type="button"
				data-testid="upload-licence-on-behalf"
				onClick={() => setMo(true)}
				style={{ ...nut, background: "#fff", color: "#1565c0", border: "1px solid #1565c0" }}>
				Upload licence on behalf of station
			</button>
		);
	return (
		<div
			style={{
				display: "grid",
				gap: 6,
				padding: 10,
				border: "1px dashed #98A2B3",
				borderRadius: 8,
				fontSize: 13,
			}}>
			<strong>Upload licence on behalf of station</strong>
			<span style={{ color: "#667085" }}>
				Replaces the current files and sets the licence back to “pending”. Then review it below as usual.
			</span>
			<input
				type="file"
				multiple
				accept=".pdf,image/*"
				onChange={(e) => setTep(e.target.files)}
			/>
			<input
				placeholder="Where did it come from? e.g. email from owner, 29/10"
				value={nguon}
				onChange={(e) => setNguon(e.target.value)}
				style={o}
			/>
			<span style={{ display: "flex", gap: 8 }}>
				<button
					type="button"
					disabled={busy}
					onClick={gui}
					style={nut}>
					{busy ? "Uploading…" : "Upload"}
				</button>
				<button
					type="button"
					onClick={() => setMo(false)}
					style={{ ...nut, background: "#fff", color: "#344054", border: "1px solid #D0D5DD" }}>
					Cancel
				</button>
			</span>
			{tb ? <span style={{ color: "#B42318" }}>{tb}</span> : null}
		</div>
	);
}

export function TaiThayChiDinh(props: { partnerId: string; onDone?: () => void }) {
	const [mo, setMo] = useState(false);
	const [tep, setTep] = useState<FileList | null>(null);
	const [chuTk, setChuTk] = useState("");
	const [nguoiKy, setNguoiKy] = useState("");
	const [nguon, setNguon] = useState("");
	const [busy, setBusy] = useState(false);
	const [tb, setTb] = useState("");
	const gui = async () => {
		setTb("");
		if (!tep?.length || !chuTk.trim() || !nguoiKy.trim() || !nguon.trim())
			return setTb("Fill in every field and choose the signed letter.");
		setBusy(true);
		try {
			const files = await taiTep(tep);
			await http.post(`/admin/partners/${props.partnerId}/payout-designations`, {
				holderName: chuTk.trim(),
				signerName: nguoiKy.trim(),
				files,
				source: nguon.trim(),
			});
			setMo(false);
			setTep(null);
			props.onDone?.();
		} catch (e) {
			setTb(loiCua(e));
		} finally {
			setBusy(false);
		}
	};
	if (!mo)
		return (
			<button
				type="button"
				data-testid="upload-designation-on-behalf"
				onClick={() => setMo(true)}
				style={{ ...nut, background: "#fff", color: "#1565c0", border: "1px solid #1565c0" }}>
				Upload payout letter on behalf of station
			</button>
		);
	return (
		<div
			style={{
				display: "grid",
				gap: 6,
				padding: 10,
				border: "1px dashed #98A2B3",
				borderRadius: 8,
				fontSize: 13,
			}}>
			<strong>Upload payout account designation letter</strong>
			<span style={{ color: "#667085" }}>
				Licence must be approved first. Another admin approves it (or you, with a reason).
			</span>
			<input
				placeholder="Account holder name — exactly as on the payout account"
				value={chuTk}
				onChange={(e) => setChuTk(e.target.value)}
				style={o}
			/>
			<input
				placeholder="Signed by (legal representative's full name)"
				value={nguoiKy}
				onChange={(e) => setNguoiKy(e.target.value)}
				style={o}
			/>
			<input
				type="file"
				multiple
				accept=".pdf,image/*"
				onChange={(e) => setTep(e.target.files)}
			/>
			<input
				placeholder="Where did it come from? e.g. email from owner, 29/10"
				value={nguon}
				onChange={(e) => setNguon(e.target.value)}
				style={o}
			/>
			<span style={{ display: "flex", gap: 8 }}>
				<button
					type="button"
					disabled={busy}
					onClick={gui}
					style={nut}>
					{busy ? "Uploading…" : "Upload"}
				</button>
				<button
					type="button"
					onClick={() => setMo(false)}
					style={{ ...nut, background: "#fff", color: "#344054", border: "1px solid #D0D5DD" }}>
					Cancel
				</button>
			</span>
			{tb ? <span style={{ color: "#B42318" }}>{tb}</span> : null}
		</div>
	);
}
